import React from 'react';

import { ADMIN_PERMISSIONS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { PermissionIcon } from '@Generic/icons';
import { ADMIN_ROLE_PAGE_PATH } from '@ApplicationWide/constants/routes';

const PermissionsPage = React.lazy(() => import('../../../pages/PermissionsPage/PermissionPage'));

export default {
  label: 'admin-page.permissions.btn-label',
  group: ADMIN,
  to: ADMIN_ROLE_PAGE_PATH,
  route: ADMIN_ROLE_PAGE_PATH,
  component: PermissionsPage,
  icon: <PermissionIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_PERMISSIONS,
  area: ADMIN_PERMISSIONS,
  hasNavBar: true,
};
